import React, { useState } from "react";
import { Button, Modal, Box, Typography } from "@mui/material";
import NotificationsIcon from '@mui/icons-material/Notifications';

const SubscribeButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);

  return (
    <>
      <Button
        data-testid="subscribe-button"
        onClick={handleOpenModal}
        variant="contained"
        sx={{
          borderRadius: "50px",
          px: 3,
          py: 1.5,
          textTransform: "none",
        }}
      >
        <NotificationsIcon/> Subscribe to our Newsletter
      </Button>
      <Modal
        open={open}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", md: "30%" },
            backgroundColor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxHeight: "90vh",
            overflowY: "visible",
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Subscribe
          </Typography>
          <iframe
            src={import.meta.env.VITE_MAILERLITE_URL}
            title="Subscribe Form"
            style={{
              width: "100%",
              height: "300px",
              border: "none",
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default SubscribeButton;
